var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.images.length > 0)?_c('div',[_c('image-collection',{staticClass:"flex justify-center -mt-6 mb-6",attrs:{"images":_vm.images}})],1):_vm._e(),_c('div',[_c('rich-text-field',{staticClass:"mt-4",attrs:{"hideBorder":true,"showEditor":false},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }